module.exports = __webpack_public_path__ + "img/MaskGroup6.3f11f0af.svg";